import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-233f2b12")

_pushScopeId("data-v-233f2b12")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", null, "Welcome", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("ul", { class: "bg-bubbles" }, [
  /*#__PURE__*/_createVNode("li"),
  /*#__PURE__*/_createVNode("li"),
  /*#__PURE__*/_createVNode("li"),
  /*#__PURE__*/_createVNode("li"),
  /*#__PURE__*/_createVNode("li"),
  /*#__PURE__*/_createVNode("li"),
  /*#__PURE__*/_createVNode("li"),
  /*#__PURE__*/_createVNode("li"),
  /*#__PURE__*/_createVNode("li"),
  /*#__PURE__*/_createVNode("li")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ["wrapper", _ctx.wrapperClass]
  }, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode("form", {
        class: ["form", _ctx.formClass]
      }, [
        _withDirectives(_createVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.username = $event)),
          type: "text",
          placeholder: "Username",
          autocomplete: "on"
        }, null, 512), [
          [_vModelText, _ctx.username]
        ]),
        _withDirectives(_createVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.password = $event)),
          type: "password",
          placeholder: "Password",
          autocomplete: "on"
        }, null, 512), [
          [_vModelText, _ctx.password]
        ]),
        _createVNode("button", {
          onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"])),
          type: "submit",
          id: "login-button"
        }, "Login")
      ], 2)
    ]),
    _hoisted_3
  ], 2))
})